import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { uri } from '@bo-client/shared/constants/uri';
import { FormBuilder } from '@angular/forms';
import { HttpHapService } from '@bo-client/core/http/http-hap.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-tm-validate-installer-pass',
  templateUrl: './tm-validate-installer-pass.component.html',
  styleUrls: ['./tm-validate-installer-pass.component.scss']
})
export class TmValidateInstallerPassComponent implements OnInit {
  private validatePassToken: string;
  public data: any;
  public hasError: boolean;

  constructor(
    private fb: FormBuilder,
    private currentRoute: ActivatedRoute,
    private router: Router,
    private httpHapService: HttpHapService,
    private toastService: ToastrService
  ) {}

  ngOnInit(): void {
    // check if the homepage is loading to change the password. If yes open a dialog to set the new password
    this.validatePassToken = this.currentRoute.snapshot.paramMap.get('token');
    this.checkIfTokenIsValid(this.validatePassToken);
  }

  checkIfTokenIsValid(token: string) {
    this.httpHapService.get(uri.tmValidatePass + '?validationToken=' + token).subscribe(
      (result) => {
        console.log(result);
        this.data = result;
      },
      (error) => {
        if (error.error) {
          this.toastService.error(error.error.message);
          this.hasError = true;
        } else {
          console.log(error);
        }
      }
    );
  }
}
